import React from 'react';
import classNames from 'classnames';

import _Base from './../_Base';

import {Button} from '@components';
import {Props} from './types';

import './index.scss';

const Normal: React.FC<Props> = props => {
  return (
    <_Base
      title={props.title}
      isModal={props.isModal}
      handleCloseModal={props.handleCloseModal}
      size={props.size}
      scroll={props.scroll}
      isAutoClose={props.isAutoClose}
      hideCloseIcon={props.hideCloseIcon}
      type={props.type}
    >
      <div className="a__common-modal">
        <div className="w__message">{props.message}</div>
        {props.children}
        <div>
          {props.buttonColor && (
            <Button.Normal
              text={props.buttonText}
              onClick={props.onClick}
              onSubmit={props.onSubmit}
              color={props.buttonColor}
              loading={props.loading}
              disabled={props.disabled}
              type={props.buttonType}
            />
          )}
          {props.hiddenCancelButton ? null : (
            <div
              className={classNames('w__modal-buttons', {scroll: props.scroll})}
            >
              <Button.Normal
                disabled={props.disabled}
                text={props.cancelText || 'キャンセル'}
                onClick={() => props.handleCloseModal(!props.isModal)}
                className={classNames({isBelow: props.buttonColor})}
              />
            </div>
          )}
        </div>
      </div>
    </_Base>
  );
};
export default Normal;
